import React from 'react';
import moment from 'moment';

import { subtractTimeZone } from 'helpers';
import { Dropdown, Menu, Space } from 'components-antd';

import styles from './styles.module.scss';

export function tableColumns(onLoginCick) {
  const handleLoginCLick = (e, row) => {
    e.stopPropagation();
    onLoginCick(row);
  };

  const columns = [
    {
      title: 'Name',
      key: 'FirstName',
      dataIndex: 'FirstName',
      sorter: (a, b) => {
        let aName = `${a?.FirstName} ${a?.LastName}`;
        let bName = `${b?.FirstName} ${b?.LastName}`;
        return aName?.localeCompare(bName);
      },
      width: 200,
      render: (_, row) => {
        return <span className={styles.tableText}>{`${row?.FirstName} ${row?.LastName}`}</span>;
      },
    },
    {
      title: 'Email',
      key: 'Email',
      dataIndex: 'Email',
      width: 300,
      sorter: (a, b) => {
        if (a.Email < b.Email) return -1;
        if (a.Email > b.Email) return 1;
        return 0;
      },
      render: (_, { Email }) => {
        return <span className={styles.tableText}>{Email}</span>;
      },
    },
    {
      title: 'Phone',
      key: 'Phone',
      dataIndex: 'Phones',
      width: 200,
      sorter: (a, b) => {
        let aPhone = a?.Phones?.find((phone) => phone?.IsPrimary)?.PhoneNumber;
        let bPhone = b?.Phones?.find((phone) => phone?.IsPrimary)?.PhoneNumber;
        if (aPhone < bPhone) return -1;
        if (aPhone > bPhone) return 1;
        return 0;
      },
      render: (_, { Phones }) => {
        let phone = Phones?.find((phone) => phone?.IsPrimary)?.PhoneNumber;
        return <span className={styles.tableText}>{phone}</span>;
      },
    },
    {
      title: 'Last Login',
      key: 'lastLogin',
      dataIndex: 'ClientLastLogin',
      width: 150,
      sorter: (a, b) => moment(a.ClientLastLogin).unix() - moment(b.ClientLastLogin).unix(),
      render: (_, row) => {
        let loginDate = row?.ClientLastLogin
          ? subtractTimeZone(row?.ClientLastLogin, 'M/D/YYYY')
          : '';
        return (
          <>
            {loginDate ? (
              <span className={styles.loginLink} onClick={(e) => handleLoginCLick(e, row)}>
                {loginDate}
              </span>
            ) : (
              <span className={styles.tableText}>{`N/A`}</span>
            )}
          </>
        );
      },
    },
    {
      title: 'Date Joined',
      key: 'dateJoined',
      dataIndex: 'CreatedDate',
      width: 150,
      sorter: (a, b) => moment(a.CreatedDate).unix() - moment(b.CreatedDate).unix(),
      render: (_, { CreatedDate }) => {
        let createdDate = CreatedDate ? subtractTimeZone(CreatedDate, 'M/D/YYYY') : 'N/A';
        return <span className={styles.tableText}>{createdDate}</span>;
      },
    },
  ];

  return columns;
}
